module.exports = __webpack_public_path__ + "img/horizontal_7_2_pp2_0.2d395e17.png";